import ApiPartnerGraphiqlPage from "readmin_pages/ApiPartnerGraphiqlPage";
import ReadminDashboard from "readmin_pages/dashboard/ReadminDashboard";
import GamesRefereeManagementPage from "readmin_pages/games/GamesRefereeManagementPage";
import OpsWarningsPage from "readmin_pages/ops_warnings/OpsWarningsPage";
import {
  AdAssetPage,
  AdPresetPage,
  AiGameStatsRequestPage,
  AiStatsProviderPage,
  ApiPartnerApiCompetitionPage,
  ApiPartnerApiCourtPage,
  ApiPartnerApiGameSchedulePage,
  ApiPartnerApiGradePage,
  ApiPartnerApiGraphqlRequestPage,
  ApiPartnerApiOrganisationPage,
  ApiPartnerApiProfilePage,
  ApiPartnerApiTeamPage,
  ApiPartnerPage,
  AwsEc2InstancePage,
  BetaFeaturePage,
  CameraModelPage,
  CameraPage,
  CityPage,
  CompetitionPage,
  CourtPage,
  DeliveryPage,
  DevicePortMappingPage,
  EventPage,
  EventVideoPage,
  GamePage,
  GameSchedulePage,
  GameSubmissionPage,
  GdAssociationPage,
  GdSubmissionPage,
  GdVenuePage,
  IncidentPage,
  LeaderboardTablePage,
  LeaguePage,
  LiveStreamPage,
  MotioncropTestPage,
  MotioncropTestReportPage,
  NetworkDevicePage,
  OnsenPopupPromoPage,
  OrgAdminPage,
  OrgPage,
  OriginalVideoRequestPage,
  PersonPage,
  PlayHqOrganisationPage,
  PotwCompetitionPage,
  PotwEntryPage,
  PotwRatingPage,
  PotwVideoPage,
  PublicLeaguePagePage,
  RecordingBlockPage,
  RecordingPage,
  ScorekeeperDevicePage,
  ScorekeeperGamePage,
  ScorekeeperUserPage,
  SendgridEventPage,
  SignupPage,
  SurfacePage,
  TeamPage,
  TeamRegistrationPage,
  UsageReportEntryPage,
  UserPage,
  VenueAdminPage,
  VenuePage,
  VenueServerChefRunPage,
  VenueServerCommandPage,
  VenueServerPage,
  VenueServerVideoFilePage,
  VideoCutAttemptPage,
  VideoEncodingJobPage,
  VideoEncodingJobRequestPage,
  VideoObjectPage,
  VideoPage,
  VideoVersionPage,
} from "readmin_pages/shared/readminObjectPages";
import {
  AdAssetsPage,
  AdPresetsPage,
  AiGameStatsRequestsPage,
  AiStatsProvidersPage,
  ApiPartnerApiCompetitionsPage,
  ApiPartnerApiCourtsPage,
  ApiPartnerApiGameSchedulesPage,
  ApiPartnerApiGraphqlRequestsPage,
  ApiPartnerApiOrganisationsPage,
  ApiPartnerApiProfilesPage,
  ApiPartnerApiTeamsPage,
  ApiPartnersPage,
  AwsEc2InstancesPage,
  BetaFeaturesPage,
  CameraModelsPage,
  CamerasPage,
  CitiesPage,
  CompetitionsPage,
  CourtsPage,
  DeliveriesPage,
  DevicePortMappingsPage,
  EventsPage,
  EventVideosPage,
  GameSchedulesPage,
  GamesPage,
  GameSubmissionsPage,
  GdAssociationsPage,
  GdVenuesPage,
  IncidentsPage,
  LeaguesPage,
  LiveStreamsPage,
  MotioncropTestReportsPage,
  MotioncropTestsPage,
  NetworkDevicesPage,
  NotesPage,
  OnsenPopupPromosPage,
  OrgAdminsPage,
  OrgsPage,
  OriginalVideoRequestsPage,
  PaperTrailVersionsPage,
  PeoplePage,
  PlayHqOrganisationsPage,
  PotwCompetitionsPage,
  PotwEntriesPage,
  PotwRatingsPage,
  PotwVideosPage,
  PublicLeaguePagesPage,
  RecordingBlocksPage,
  RecordingsPage,
  ScorekeeperDevicesPage,
  ScorekeeperGamesPage,
  ScorekeeperUsersPage,
  SendgridEventsPage,
  SignupsPage,
  SurfacesPage,
  TeamRegistrationsPage,
  TeamsPage,
  UsageReportPage,
  UsersPage,
  VenueAdminsPage,
  VenueServerChefRunsPage,
  VenueServerCommandsPage,
  VenueServersPage,
  VenuesPage,
  VideoCutAttemptsPage,
  VideoEncodingJobRequestsPage,
  VideoEncodingJobsPage,
  VideoObjectsPage,
  VideosPage,
} from "readmin_pages/shared/readminObjectsPages";

const READMIN_ROUTES = {
  // readmin, special pages
  "/": ReadminDashboard,
  "/ops_warnings": OpsWarningsPage,

  // readmin root-level pages
  "/aws_ec2_instances": AwsEc2InstancesPage,
  "/aws_ec2_instances/:awsEc2InstanceId": AwsEc2InstancePage,
  "/ad_assets": AdAssetsPage,
  "/ad_presets": AdPresetsPage,
  "/beta_features": BetaFeaturesPage,
  "/beta_features/:betaFeatureId": BetaFeaturePage,
  "/cameras": CamerasPage,
  "/cameras/:cameraId": CameraPage,
  "/camera_models": CameraModelsPage,
  "/camera_models/:cameraModelId": CameraModelPage,
  "/cities": CitiesPage,
  "/cities/:cityId": CityPage,
  "/orgs": OrgsPage,
  "/org_admins": OrgAdminsPage,
  "/courts": CourtsPage,
  "/deliveries": DeliveriesPage,
  "/deliveries/:deliveryId": DeliveryPage,
  "/video_encoding_job_requests": VideoEncodingJobRequestsPage,
  "/video_encoding_job_requests/:videoEncodingJobRequestId": VideoEncodingJobRequestPage,
  "/video_encoding_jobs": VideoEncodingJobsPage,
  "/video_encoding_jobs/:videoEncodingJobId": VideoEncodingJobPage,
  "/events": EventsPage,
  "/event_videos": EventVideosPage,
  "/event_videos/:eventVideoId": EventVideoPage,
  "/games": GamesPage,
  "/game_schedules": GameSchedulesPage,
  "/game_submissions": GameSubmissionsPage,
  "/game_submissions/:gameSubmissionId": GameSubmissionPage,
  "/incidents": IncidentsPage,
  "/leagues": LeaguesPage,
  "/live_streams": LiveStreamsPage,
  "/network_devices": NetworkDevicesPage,
  "/network_devices/:networkDeviceId": NetworkDevicePage,
  "/motioncrop_tests": MotioncropTestsPage,
  "/motioncrop_tests/:motioncropTestId": MotioncropTestPage,
  "/motioncrop_test_reports": MotioncropTestReportsPage,
  "/motioncrop_test_reports/:motioncropTestReportId": MotioncropTestReportPage,
  "/notes": NotesPage,
  "/original_video_requests": OriginalVideoRequestsPage,
  "/original_video_requests/:originalVideoRequestId": OriginalVideoRequestPage,
  "/onsen_popup_promos": OnsenPopupPromosPage,
  "/onsen_popup_promos/:onsenPopupPromoId": OnsenPopupPromoPage,
  "/people": PeoplePage,
  "/paper_trail_versions": PaperTrailVersionsPage,
  "/play_hq_organisations": PlayHqOrganisationsPage,
  "/play_hq_organisations/:playHqOrganisationId": PlayHqOrganisationPage,
  "/potw_competitions": PotwCompetitionsPage,
  "/potw_entries": PotwEntriesPage,
  "/potw_ratings": PotwRatingsPage,
  "/potw_videos": PotwVideosPage,
  "/potw_videos/:potwVideoId": PotwVideoPage,
  "/gd_submissions/:gdSubmissionId": GdSubmissionPage,
  "/public_league_pages": PublicLeaguePagesPage,
  "/recording_blocks": RecordingBlocksPage,
  "/recording_blocks/:recordingBlockId": RecordingBlockPage,
  "/scorekeeper_devices": ScorekeeperDevicesPage,
  "/scorekeeper_devices/:scorekeeperDeviceId": ScorekeeperDevicePage,
  "/scorekeeper_games": ScorekeeperGamesPage,
  "/scorekeeper_games/:scorekeeperGameId": ScorekeeperGamePage,
  "/scorekeeper_users": ScorekeeperUsersPage,
  "/sendgrid_events": SendgridEventsPage,
  "/sendgrid_events/:sendgridEventId": SendgridEventPage,
  "/surfaces": SurfacesPage,
  "/surfaces/:surfaceId": SurfacePage,
  "/teams": TeamsPage,
  "/team_registrations": TeamRegistrationsPage,
  "/signups": SignupsPage,
  "/users": UsersPage,
  "/users/:userId": UserPage,
  "/venue_admins": VenueAdminsPage,
  "/venue_admins/:venueAdminId": VenueAdminPage,
  "/venue_server_commands": VenueServerCommandsPage,
  "/venue_server_commands/:venueServerCommandId": VenueServerCommandPage,
  "/venue_server_chef_runs": VenueServerChefRunsPage,
  "/venue_server_chef_runs/:venueServerChefRunId": VenueServerChefRunPage,
  "/venue_servers": VenueServersPage,
  "/venue_servers/:venueServerId": VenueServerPage,
  "/venue_server_video_files/:venueServerVideoFileId": VenueServerVideoFilePage,
  "/venues": VenuesPage,
  "/venues/:venueId": VenuePage,
  "/videos": VideosPage,
  "/videos/:videoId": VideoPage,
  "/video_cut_attempts": VideoCutAttemptsPage,
  "/video_cut_attempts/:videoCutAttemptId": VideoCutAttemptPage,
  "/video_objects": VideoObjectsPage,
  "/video_objects/:videoObjectId": VideoObjectPage,
  "/video_versions/:videoVersionId": VideoVersionPage,
  "/gd_associations": GdAssociationsPage,
  "/gd_associations/:gdAssociationId": GdAssociationPage,
  "/gd_venues": GdVenuesPage,
  "/gd_venues/:gdVenueId": GdVenuePage,
  "/device_port_mappings": DevicePortMappingsPage,
  "/device_port_mappings/:devicePortMappingId": DevicePortMappingPage,
  "/competitions": CompetitionsPage,

  // readmin org-level pages
  "/orgs/:orgId": OrgPage,
  "/orgs/:orgId/games/manage_referees": GamesRefereeManagementPage,
  // resources
  "/orgs/:orgId/ad_assets": AdAssetsPage,
  "/orgs/:orgId/ad_assets/:adAssetId": AdAssetPage,
  "/orgs/:orgId/ad_presets": AdPresetsPage,
  "/orgs/:orgId/ad_presets/:adPresetId": AdPresetPage,
  "/orgs/:orgId/deliveries": DeliveriesPage,
  "/orgs/:orgId/deliveries/:deliveryId": DeliveryPage,
  "/orgs/:orgId/teams": TeamsPage,
  "/orgs/:orgId/teams/:teamId": TeamPage,
  "/orgs/:orgId/team_registrations": TeamRegistrationsPage,
  "/orgs/:orgId/team_registrations/:teamRegistrationId": TeamRegistrationPage,
  "/orgs/:orgId/games": GamesPage,
  "/orgs/:orgId/games/:gameId": GamePage,
  "/orgs/:orgId/game_schedules": GameSchedulesPage,
  "/orgs/:orgId/game_schedules/:gameScheduleId": GameSchedulePage,
  "/orgs/:orgId/game_submissions": GameSubmissionsPage,
  "/orgs/:orgId/game_submissions/:gameSubmissionId": GameSubmissionPage,
  "/orgs/:orgId/videos": VideosPage,
  "/orgs/:orgId/videos/:videoId": VideoPage,
  "/orgs/:orgId/incidents": IncidentsPage,
  "/orgs/:orgId/incidents/:incidentId": IncidentPage,
  "/orgs/:orgId/leagues": LeaguesPage,
  "/orgs/:orgId/leagues/:leagueId": LeaguePage,
  "/orgs/:orgId/live_streams": LiveStreamsPage,
  "/orgs/:orgId/live_streams/:liveStreamId": LiveStreamPage,
  "/orgs/:orgId/leaderboard_tables/:leaderboardTableId": LeaderboardTablePage,
  "/orgs/:orgId/people": PeoplePage,
  "/orgs/:orgId/people/:personId": PersonPage,
  "/orgs/:orgId/potw_competitions": PotwCompetitionsPage,
  "/orgs/:orgId/potw_competitions/:potwCompetitionId": PotwCompetitionPage,
  "/orgs/:orgId/potw_entries": PotwEntriesPage,
  "/orgs/:orgId/potw_entries/:potwEntryId": PotwEntryPage,
  "/orgs/:orgId/potw_ratings": PotwRatingsPage,
  "/orgs/:orgId/potw_ratings/:potwRatingId": PotwRatingPage,
  "/orgs/:orgId/public_league_pages": PublicLeaguePagesPage,
  "/orgs/:orgId/public_league_pages/:publicLeaguePageId": PublicLeaguePagePage,
  "/orgs/:orgId/courts": CourtsPage,
  "/orgs/:orgId/courts/:courtId": CourtPage,
  "/orgs/:orgId/recordings": RecordingsPage,
  "/orgs/:orgId/recordings/:recordingId": RecordingPage,
  "/orgs/:orgId/scorekeeper_users": ScorekeeperUsersPage,
  "/orgs/:orgId/scorekeeper_users/:scorekeeperUserId": ScorekeeperUserPage,
  "/orgs/:orgId/events": EventsPage,
  "/orgs/:orgId/events/:eventId": EventPage,
  "/orgs/:orgId/notes": NotesPage,
  "/orgs/:orgId/usage_report": UsageReportPage,
  "/orgs/:orgId/usage_report_entries/:usageReportEntryId": UsageReportEntryPage,
  "/orgs/:orgId/org_admins": OrgAdminsPage,
  "/orgs/:orgId/org_admins/:orgAdminId": OrgAdminPage,
  "/orgs/:orgId/venues/:venueId": VenuePage,
  "/orgs/:orgId/competitions": CompetitionsPage,
  "/orgs/:orgId/competitions/:competitionId": CompetitionPage,
  "/orgs/:orgId/signups": SignupsPage,
  "/orgs/:orgId/signups/:signupId": SignupPage,

  // readmin api-level pages
  "/api_partners": ApiPartnersPage,
  "/api_partners/:apiPartnerId": ApiPartnerPage,
  "/api_partners/:apiPartnerId/graphiql": ApiPartnerGraphiqlPage,
  // resources
  "/api_partners/:apiPartnerId/api_organisations": ApiPartnerApiOrganisationsPage,
  "/api_partners/:apiPartnerId/api_organisations/:apiOrganisationId": ApiPartnerApiOrganisationPage,
  "/api_partners/:apiPartnerId/api_courts": ApiPartnerApiCourtsPage,
  "/api_partners/:apiPartnerId/api_courts/:apiCourtId": ApiPartnerApiCourtPage,
  "/api_partners/:apiPartnerId/api_teams": ApiPartnerApiTeamsPage,
  "/api_partners/:apiPartnerId/api_teams/:apiTeamId": ApiPartnerApiTeamPage,
  "/api_partners/:apiPartnerId/api_competitions": ApiPartnerApiCompetitionsPage,
  "/api_partners/:apiPartnerId/api_competitions/:apiCompetitionId": ApiPartnerApiCompetitionPage,
  "/api_partners/:apiPartnerId/api_game_schedules": ApiPartnerApiGameSchedulesPage,
  "/api_partners/:apiPartnerId/api_game_schedules/:apiGameScheduleId": ApiPartnerApiGameSchedulePage,
  "/api_partners/:apiPartnerId/api_profiles": ApiPartnerApiProfilesPage,
  "/api_partners/:apiPartnerId/api_profiles/:apiProfileId": ApiPartnerApiProfilePage,
  "/api_partners/:apiPartnerId/api_grades/:apiGradeId": ApiPartnerApiGradePage,
  "/api_partners/:apiPartnerId/api_graphql_requests": ApiPartnerApiGraphqlRequestsPage,
  "/api_partners/:apiPartnerId/api_graphql_requests/:apiGraphqlRequestId": ApiPartnerApiGraphqlRequestPage,

  // AI stats providers (Preciser and future providers)
  "/ai_stats_providers": AiStatsProvidersPage,
  "/ai_stats_providers/:aiStatsProviderId": AiStatsProviderPage,
  "/ai_game_stats_requests": AiGameStatsRequestsPage,
  "/ai_game_stats_requests/:aiGameStatsRequestId": AiGameStatsRequestPage,
};

export default READMIN_ROUTES;
